@switch (currentSidebarType()) {
  @case (SelectionTypes.EditorHeader) {
    <guideline-sidebar-header />
  }
  @case (SelectionTypes.Flowchart) {
    <guideline-flowchart-sidebar-wrapper [selectedElementId]="selectedElement().uniqueId" [selectedWidgetId]="selectedElement().widgetId" />
  }
  @case (SelectionTypes.Widget) {
    @if (selectedWidget()) {
      @switch (selectedWidget().widgetType) {
        @case ('component') {
          <guideline-editor-component-sidebar-wrapper [widget]="selectedWidget()" />
        }
        @case ('component-list') {
          <guideline-editor-component-list-sidebar-wrapper [widget]="selectedWidget()" />
        }
        @case ('chapter') {
          <guideline-editor-chapter-sidebar-wrapper [widget]="selectedWidget()" />
        }
        @case ('workflow') {
          <tt-guideline-workflow-sidebar-wrapper [widget]="selectedWidget()" />
        }
        @case ('flowchart') {
          <tt-guideline-flowchart-widget-sidebar />
        }
      }
    } @else {
      <shared-sidebar-placeholder />
    }
  }
}
